<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title1"><h1 class="title"><strong class="b">ACKNOWLEDGMENTS</strong></h1>
<p class="p"><span>This book would only be an idea without the support and generosity of the Ijams grandchildren, George Kern, Martha Kern, and Mary Gallant, who provided full access to the Ijams family photography archives, most of which had not seen the light of day for many years. Thank you so much for your time, patience, and friendship.</span></p>
<p class="p-indent"><span>Special thanks goes to Steve Cotham, manager of East Tennessee History Center’s Calvin M. McClung Historical Collection, who set me on the right path and contributed images; Maggie Bullwinkel, editor with Arcadia Publishing, for enthusiasm and unwavering support for the project; Paul Efird, <em class="i">Knoxville News Sentinel</em>, for archive scans; Annette Hartigan, archivist with the Great Smoky Mountains National Park, for sharing valuable time and resources; Norma Lowe, volunteer with the Girl Scout Council of the Southern Appalachians, for help navigating archive material; Lynn Faust, for turning a brief mountaintop encounter into a new friendship with descendants of Col. W. B. Townsend and Mabel Ijams; Larry Franklin and his dear wife, Cissie, who also shared rare photographs; Sally Judiscak and Marielle Robertson for editing assistance; and Jack Neely for research assistance, editing, and expanding my historical horizons.</span></p>
<p class="p-indent"><span>Thanks also to the following people who greatly enhanced this book by sharing photographs and memories or helping with identifications: Stephen Lyn Bales, Robert Bell, Edna Bell, Peg Beute, Jim Campbell, Marcia Davis, Mary Farmer, Kathleen Hancock, Lynn Montgomery, Alan Mealka, Harry Moore, Pam Petko-Seus, Nancy Tanner, Jane Williams, James E. Thompson, Thompson Photo Products, and Tennessee Ornithological Society.</span></p>
<p class="p-indent"><span>Finally, thanks to Julie and Isabel James for sparing family time for me to bring this project to fruition.</span></p>
<p class="p-indent"><span>Unless noted otherwise, all photographs are used courtesy of the Ijams family collection.</span></p></a></div><a id="title1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439626160_ack01.vue?21b19049